import React from "react";
import "./Carousel.css";
import MainMenu from "../navigations/MainMenu";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Carousel = () => {
  return (
    <div
      className="object-contain flex justify-center items-center relative carousel__container"
      style={{
        backgroundImage: `linear-gradient(
          rgb(0, 0, 0, 0.6),
          rgb(0, 12, 0, 0.5)
  ), url("/images/hero.png")`,
        height: "80vh",
        width: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center center",
      }}
    >
      <div className="absolute top-0 left-0">
        <MainMenu />
      </div>
      <motion.div
        animate={{ x: 0 }}
        initial={{ x: -100 }}
        transition={{ duration: 0.7 }}
        className="absolute left-3 md:left-16"
      >
        {/** Heading */}
        <motion.div className="bg-gray-100 bg-opacity-60 p-2 sm:p-4 text-lg md:text-2xl text-green-900">
          <motion.p
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.9 }}
            className="font-semibold"
          >
            Welcome To
          </motion.p>
          <motion.h1
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.9 }}
            className="font-bold text-2xl md:text-4xl"
          >
            St. John's High School
          </motion.h1>
          <motion.p
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.9 }}
            className="text-sm md:text-base"
          >
            "I am the light of the world" Jn. 8:12
          </motion.p>
        </motion.div>
        {/** Sub heading */}
        <div className="bg-gray-100  bg-opacity-60 my-5 p-2 md:p-4 text-sm md:text-2xl text-green-900">
          <motion.p
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.9 }}
          >
            Affiliated to CBSE(English Medium) ESTD.: 1988
          </motion.p>
        </div>

        <Link to="/about">
          <motion.button
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.9 }}
            className="bg-yellow-400 bg-opacity-75 p-2 md:p-4 text-sm md:text-xl font-semibold font-serif flex items-center gap-x-2"
          >
            Explore More <BsArrowRight className="" />
          </motion.button>
        </Link>
      </motion.div>
    </div>
  );
};

export default Carousel;
